import { useState, useEffect } from 'react';

const useLivroAcademico = (livroId) => {
    const [ebook, setEbook] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const apiUrl = process.env.REACT_APP_API;

    useEffect(() => {
        const fetchEbook = async () => {
            setIsLoading(true);
            try {
                const response = await fetch(apiUrl + "ebook/" + livroId);
                if (!response.ok) {
                    throw new Error('Falha ao buscar o ebook');
                }
                const data = await response.json();
                setEbook(data);
            } catch (error) {
                setError(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchEbook();

        // Cleanup function in case component unmounts before fetch completes
        return () => {
            // Abort fetch or any cleanup logic if needed
        };
    }, [livroId]);

    return { ebook, isLoading, error };
};

export default useLivroAcademico;
